// libs
import { styled } from '@nykaa/ui-components';

// components
import { ActionButton } from 'shared/components/Header/MobileHeader/styles/header';

export const AccountButton = styled(ActionButton)`
  position: relative;
  display: flex;
  justify-items: center;
  align-items: center;
  width: 24px;

  svg {
    fill: ${({ theme }) => theme.colors.textPrimary};
  }
`;
